import CategoriesService from '@/common/services/categories.service';
import { FETCH_CATEGORIES, SELECT_CATEGORY } from '../actions/category.actions';
import { SET_CATEGORIES, SET_SELECTED_CATEGORY, TRY_FETCH_CATEGORIES } from '../mutations/category.mutations';
import { SET_ERROR } from '../mutations/common.mutations';
import { getError } from '@/common/services/http.service';

const initialState = {
  entities: [],
  errors: null,
  pending: false,
  selectedCategory: null,
  loaded: false,
};

const state = {
  ...initialState
};

const actions = {
  [FETCH_CATEGORIES](context) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_FETCH_CATEGORIES);

      CategoriesService.get()
          .then(data => {
            context.commit(SET_CATEGORIES, data);
            resolve(data);
          })
          .catch(response => {
            context.commit(SET_ERROR, getError(response));
            reject('Error loading categories');
          });
    });
  },
  [SELECT_CATEGORY](context, category) {
    return new Promise(resolve => {
      context.commit(SET_SELECTED_CATEGORY, category);
      resolve(true);
    });
  }
};

const mutations = {
  [TRY_FETCH_CATEGORIES](state) {
    state.errors = [];
    state.pending = true;
    state.loaded = false;
  },
  [SET_CATEGORIES](state, categories) {
    state.entities = categories;
    state.pending = false;
    state.loaded = true;
  },
  [SET_SELECTED_CATEGORY](state, category) {
    state.selectedCategory = category;
  },
  [SET_ERROR](state, errors) {
    state.pending = false;
    state.errors = errors;
    state.loaded = false;
  },
};

const getters = {
  categories(state) {
    return state.entities;
  },
  category(state) {
    return state.selectedCategory;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
